






























































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import DeliverySacRequest from '@/model/request/DeliverySacRequest'
import {IResource, Collection} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import { Period } from '@/enums/Period'
import OcorrenciaTracking from '@/model/resource/OcorrenciaTracking'

@Component
export default class FilterDeliverySac extends Vue {
  @Prop({required: true}) value!: DeliverySacRequest
  @Prop({type: Array, default: () => []}) hidden!: string[]

  Period = Period

  get isCpfCnpj() {
    return this.value.documentDestinatario !== null && this.value.documentDestinatario.length <= 14
  }

  // TRK-3812 Campo de pesquisa por Nome do Destinatário só está disponível para Helm
  get showNomeDestinatario() {
    return Helper.isHelm()
  }

  get docMask() {
    if (this.isCpfCnpj) {
      return [
        this.$t('format.cpf'),
        this.$t('format.cnpj') + '#',
      ]
    }
    return this.$t('format.danfe')
  }

  allDocsEvent(item: IResource, cache: IResource[]) {
    this.value.populateAllDocs(cache)
  }

  searchByCTEEvent(item: IResource, cache: IResource[]) {
    this.value.populateSearchByCTE(cache)
  }

  cleanSearchByCtes() {
    this.value.cleanSearchByCTE()
  }

  async mounted() {

    await this.value.allTipoOcorrencia.query()
    await this.value.allOcorrenciaTracking.query()
    await this.value.allTipoInsumo.query()

    const filterDevolvida = this.value.allTipoOcorrencia.items

    const filter = this.value.allOcorrenciaTracking.items

    this.value.ocorrenciaTrackingCollection = Helper.collect(OcorrenciaTracking)

    this.value.tipoOcorrenciaDevolvidaCollection = Helper.collect(TipoOcorrencia, filterDevolvida)
    this.value.ocorrenciaTrackingCollection = Helper.collect(OcorrenciaTracking, filter)
  }
}
